import React from "react";
import { useZendesk } from "shared-hooks";
import { RouteComponentProps } from "react-router";

export default function withZendesk<P extends RouteComponentProps<any>>(
  WrappedComponent: React.ComponentType<any>
) {
  return function (props: P) {
    useZendesk(props.location.pathname);

    return <WrappedComponent {...props} />;
  };
}
